


import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import present from "../assets/StatusIcons/present.svg";
import absent from "../assets/StatusIcons/absent.svg";
import earlyout from "../assets/StatusIcons/earlyout.svg";
import leave from "../assets/StatusIcons/leave.svg";
import late from "../assets/StatusIcons/late.svg";
import halfleave from "../assets/StatusIcons/halfleave.svg";
import task from "../assets/StatusIcons/task.svg";
import active from '../assets/Dashboard/active.svg';
import inactive from '../assets/Dashboard/inactive.svg';
import trial from '../assets/Dashboard/trial.svg';
import invited from '../assets/Dashboard/invited.svg';
import request from '../assets/Dashboard/request.svg';
import process from "../assets/Dashboard/process.svg";
import overdue from "../assets/Dashboard/overdue.svg";
import received from "../assets/Wallet/received.svg";
import pending from "../assets/Wallet/pending.svg";
import { useTranslation } from 'react-i18next';
import valid from "../assets/Attendance/valid.svg"
import i18n from 'i18next';
import { getContrastTextColor } from '../utils/colorUtils';
import cancel from "../assets/StatusIcons/cancel.svg";
import expire from "../assets/StatusIcons/expire.svg";
import tobepaid from "../assets/StatusIcons/tobepaid.svg";

/** Renders SVG as a mask so the glyph uses `currentColor` (matches badge text). */
const StatusGlyphIcon = ({ src, size = 20 }) => {
  if (!src) return null;
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: "inline-block",
        width: size,
        height: size,
        flexShrink: 0,
        bgcolor: "currentColor",
        maskImage: `url(${src})`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskImage: `url(${src})`,
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
      }}
    />
  );
};

const statusIcons = {
  Present: present,
cancelled: cancel,
CANCELLED: cancel,

expired: expire,
   Validated: present,
   CLOCK_IN:present,
  Paid:present,
    paid:present,

  Completed: present,
    completed: present,
 Verified: present,
  verified: present,
    Approved: present,
        approved: present,

     APPROVED: present,
  Absent: absent,
  Invalid:absent,
 Error: absent,
  Delayed: absent,
   Rejected: absent,
      rejected: absent,

   CLOCK_OUT:absent,
      REJECTED: absent,
  Leave: leave,
  assigned: leave,
   Assigned: leave,
  Pending:leave,
    pending:leave,
  pendingPunch:halfleave,
INFO_REQUESTED:halfleave,
  PENDING:leave,
    valid:valid,
  'Early Out': earlyout,
  'Has Issues' :earlyout, 
    Ongoing: earlyout,      // ✅ Use quotes because of the space
  'Late Arrival': late,
   'in_progress': late,
  'Half Day': halfleave,
   Paused: halfleave,
    'Requested': halfleave,
        'Request': halfleave,
        toBePaid: tobepaid,
    Active: present,
      active:present,
  Invited: invited,
    invited: invited,
    Requested: request,
     Inactive: inactive,
     high:task,
     medium:task,
     urgent:task,
     u:task,
     low:task,
     invalidPunch:absent,
     validatedPunch:present,
        BACK_FROM_BREAK:halfleave,
     BREAK_END:halfleave,
     BREAK_START:late,
  // Attendance schedule classifications
  ON_TIME_CLOCK_IN: present,
  EARLY_CLOCK_IN: present,
  LATE_CLOCK_IN: late,
  ON_TIME_CLOCK_OUT: absent,
  EARLY_CLOCK_OUT: earlyout,
  LATE_CLOCK_OUT: late,
  NOT_APPLICABLE: halfleave,

};

const badgeStyle = (backgroundColor) => ({
  backgroundColor,
  color: getContrastTextColor(backgroundColor),
});

const statusStyles = {
  CLOCK_IN: badgeStyle('#22C55E'),
  Present: { backgroundColor: '#4BCE97', color: '#164B35' },
    APPROVED: badgeStyle('#22C55E'),
  Validated: badgeStyle('#16A34A'),
    Paid: {    backgroundColor: "#CFF3E1",
  color: "#0F6A4F",},
    paid: {    backgroundColor: "#CFF3E1",
  color: "#0F6A4F", },
  Completed: { backgroundColor: '#4BCE97', color: '#164B35' },
    completed: { backgroundColor: '#4BCE97', color: '#164B35' },
 Verified: { backgroundColor: '#4BCE97', color: '#164B35' },
  verified: { backgroundColor: '#4BCE97', color: '#164B35' },
  Approved: badgeStyle('#22C55E'),
    approved: badgeStyle('#22C55E'),
  cancelled:{ backgroundColor: '#FEA362', color: '#702E00' },
    CANCELLED:{ backgroundColor: '#FEA362', color: '#702E00' },

    expired:{ backgroundColor: '#091E4224', color: '#44546F' },
  Absent: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Invalid: badgeStyle('#DC2626'),
  Error: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Delayed: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Rejected: badgeStyle('#EF4444'),
  rejected: badgeStyle('#EF4444'),
    REJECTED: badgeStyle('#EF4444'),
     CLOCK_OUT: badgeStyle('#3B82F6'),
  invalidPunch: badgeStyle('#DC2626'),
  Leave: { backgroundColor: '#579DFF', color: '#09326C' },
  INFO_REQUESTED: badgeStyle('#3B82F6'),
  assigned: { backgroundColor: '#579DFF', color: '#09326C' },
    Assigned: { backgroundColor: '#579DFF', color: '#09326C' },
      BACK_FROM_BREAK: badgeStyle('#06B6D4'),
BREAK_START: badgeStyle('#F59E0B'),
          BREAK_END: badgeStyle('#06B6D4'),

Pending: badgeStyle('#F59E0B'),
pending: badgeStyle('#F59E0B'),
PENDING: badgeStyle('#F59E0B'),
pendingPunch: badgeStyle('#6B7280'),
validatedPunch: badgeStyle('#16A34A'),
  'Early Out': badgeStyle('#EAB308'),
  'Has Issues': { backgroundColor: '#9F8FEF', color: '#352C63' }, 
   Ongoing: badgeStyle('#3B82F6'),
  'Late Arrival': badgeStyle('#EF4444'),
   'in_progress': { backgroundColor: '#FEA362', color: '#702E00' },
  'Half Day': badgeStyle('#8B5CF6'),
   Paused: { backgroundColor: '#F5CD47', color: '#533F04' },
   'Requested': badgeStyle('#3B82F6'),
   'Request': badgeStyle('#3B82F6'),
     Active: { backgroundColor: '#4BCE97', color: '#164B35' },
          active: { backgroundColor: '#4BCE97', color: '#164B35' },
        Invited: { backgroundColor: '#579DFF', color: '#09326C' },
         invited: { backgroundColor: '#579DFF', color: '#09326C' },
         toBePaid: { backgroundColor: '#579DFF', color: '#09326C' },
         Requested: badgeStyle('#3B82F6'),
          Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
      low: { backgroundColor: '#BCBFC2', color: '#44546F' },
        medium: {backgroundColor: '#9B8CFF',
color: '#2D1E73'},
       high: { backgroundColor: '#FEA362', color: '#702E00' },
     urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
     valid: badgeStyle('#16A34A'),
  // Attendance schedule classifications
  ON_TIME_CLOCK_IN: badgeStyle('#10B981'),
  EARLY_CLOCK_IN: badgeStyle('#6366F1'),
  LATE_CLOCK_IN: badgeStyle('#EF4444'),
  ON_TIME_CLOCK_OUT: badgeStyle('#10B981'),
  EARLY_CLOCK_OUT: badgeStyle('#EAB308'),
  LATE_CLOCK_OUT: badgeStyle('#EA580C'),
  NOT_APPLICABLE: badgeStyle('#6B7280'),
};

const canOpenDropdown = Object.keys(statusStyles).filter(
  (status) => status !== "" && status !== "Received"
);
const showDropdownIcon = ["", "", "", "", "", ""];

const StatusDropdown = ({ currentStatus, onChange, statusOptions = [] }) => {
  const { t, i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (canOpenDropdown.includes(currentStatus)) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = (status) => {
    if (status) onChange(status);
    setAnchorEl(null);
  };
  const displayStatusLabels = {
  initiated: 'Processing',
  success: 'Paid',
  failed: 'Failed',
};
  return (
    <>
      {/* <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 0.4,
          py: 0.4,
          borderRadius: '4px',
          fontWeight: 400,
          fontFamily: 'Poppins, sans-serif',
          fontSize: '13px',
          cursor: canOpenDropdown.includes(currentStatus) ? 'pointer' : 'default',
          width: 'fit-content',
          cursor:"pointer",
              whiteSpace: 'nowrap',         // ✅ no line break

          ...statusStyles[currentStatus]
        }}
      > */}
      <Box
  onClick={handleClick}
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    px: 1,
    py: 0.4,
    borderRadius: "6px",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    cursor: canOpenDropdown.includes(currentStatus) ? "pointer" : "default",

    // 🌍 Responsive equal width logic
    flex: 1,                            // take full space inside table cell
   maxWidth: i18n.language === "es" ? 220 : 150,                   // prevent overflow
    minWidth: 120,                      // ensure equal base size
    width: "100%",                      // allow auto-fit

    ...statusStyles[currentStatus],
    color: statusStyles[currentStatus]?.color || "#333333",
  }}
>
        <StatusGlyphIcon src={statusIcons[currentStatus]} size={20} />

        <Typography
          sx={{
            fontSize: "13px",
            fontFamily: "Poppins, sans-serif",
            color: "inherit",
            minWidth: 0,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {t(`statuses.${displayStatusLabels[currentStatus] || currentStatus}`)}
        </Typography>
        {showDropdownIcon.includes(currentStatus) && (
          <ArrowDropDownIcon sx={{ fontSize: 18, color: "inherit" }} />
        )}
      </Box>

      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
       
        {statusOptions.map((status) => (
  <MenuItem key={status} onClick={() => handleClose(status)}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        color: statusStyles[status]?.color || "#333333",
      }}
    >
      <StatusGlyphIcon src={statusIcons[status]} size={16} />
      <Typography
        sx={{ fontFamily: "Poppins, sans-serif", fontSize: "13px", color: "inherit" }}
      >
        {t(`statuses.${status}`)}
      </Typography>
    </Box>
  </MenuItem>
))}
      </Menu>
    </>
  );
};

/** Same key lookup as StatusDropdown badge (`currentStatus`). */
function resolveStatusBadgeKey(statusKey, fallbackActionType) {
  if (statusKey != null && String(statusKey).trim() !== "") {
    return String(statusKey).trim();
  }
  return fallbackActionType;
}

/**
 * Pin / map dot color key: break actions always use break colors; otherwise
 * classification when styled, else action type (never default to CLOCK_IN green).
 */
function resolveMapPinStatusKey(statusKey, fallbackActionType) {
  const action =
    fallbackActionType === "BACK_FROM_BREAK" ? "BREAK_END" : fallbackActionType;

  if (action === "BREAK_START" || action === "BREAK_END") {
    return action;
  }

  const badgeKey = resolveStatusBadgeKey(statusKey, action);
  if (badgeKey && statusStyles[badgeKey]) {
    return badgeKey;
  }
  if (action && statusStyles[action]) {
    return action;
  }
  return badgeKey || action;
}

/** Background fill for pins / ledger dots — matches StatusDropdown badge `backgroundColor`. */
export function getStatusBadgeBackgroundColor(statusKey, fallbackActionType) {
  const key = resolveStatusBadgeKey(statusKey, fallbackActionType);
  const style =
    (key && statusStyles[key]) ||
    (fallbackActionType && statusStyles[fallbackActionType]) ||
    statusStyles.CLOCK_IN;
  return style?.backgroundColor ?? "#22C55E";
}

function getMapPinBackgroundColor(statusKey, fallbackActionType) {
  const key = resolveMapPinStatusKey(statusKey, fallbackActionType);
  const style =
    (key && statusStyles[key]) ||
    (fallbackActionType && statusStyles[fallbackActionType]) ||
    statusStyles.CLOCK_IN;
  return style?.backgroundColor ?? "#22C55E";
}

/** Same key as StatusDropdown `currentStatus` (classification, with break NOT_APPLICABLE → action type). */
export function resolveAttendanceStatusKey(statusKey, fallbackActionType) {
  const classification =
    statusKey != null && String(statusKey).trim() !== ""
      ? String(statusKey).trim()
      : "";
  const action = fallbackActionType;
  if (classification) {
    if (
      (action === "BREAK_START" || action === "BREAK_END") &&
      classification === "NOT_APPLICABLE"
    ) {
      return action;
    }
    return classification;
  }
  return action;
}

/** Punch indicator / map pin fill — matches legend & break/clock action colors. */
export function getAttendanceStatusDotColor(statusKey, fallbackActionType) {
  return getMapPinBackgroundColor(statusKey, fallbackActionType);
}

/** Map pin icon filled with the same color as the status badge (not a circle dot). */
export function getAttendanceStatusPinMarkerIcon(statusKey, fallbackActionType) {
  const fillColor = getMapPinBackgroundColor(statusKey, fallbackActionType);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
  <path fill="${fillColor}" stroke="#FFFFFF" stroke-width="1.5" d="M12.5 0C5.596 0 0 5.596 0 12.5c0 7.904 12.5 28.5 12.5 28.5S25 20.404 25 12.5C25 5.596 19.404 0 12.5 0z"/>
  <circle cx="12.5" cy="12" r="4.5" fill="#FFFFFF" fill-opacity="0.9"/>
</svg>`;
  const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

  if (typeof window !== "undefined" && window.google?.maps?.Size && window.google?.maps?.Point) {
    return {
      url,
      scaledSize: new window.google.maps.Size(25, 41),
      anchor: new window.google.maps.Point(12, 41),
    };
  }
  return { url };
}

/** @deprecated Use getAttendanceStatusPinMarkerIcon — kept for imports during migration */
export function getAttendanceStatusMapMarkerIcon(statusKey, fallbackActionType) {
  return getAttendanceStatusPinMarkerIcon(statusKey, fallbackActionType);
}

export default StatusDropdown;

















// import React, { useState } from 'react';
// import { Box, Menu, MenuItem, Typography } from '@mui/material';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import present from "../assets/StatusIcons/present.svg";
// import absent from "../assets/StatusIcons/absent.svg";
// import earlyout from "../assets/StatusIcons/earlyout.svg";
// import leave from "../assets/StatusIcons/leave.svg";
// import late from "../assets/StatusIcons/late.svg";
// import halfleave from "../assets/StatusIcons/halfleave.svg";
// import task from "../assets/StatusIcons/task.svg";
// import active from '../assets/Dashboard/active.svg';
// import inactive from '../assets/Dashboard/inactive.svg';
// import trial from '../assets/Dashboard/trial.svg';
// import invited from '../assets/Dashboard/invited.svg';
// import request from '../assets/Dashboard/request.svg';
// import process from "../assets/Dashboard/process.svg";
// import overdue from "../assets/Dashboard/overdue.svg";
// import received from "../assets/Wallet/received.svg";
// import pending from "../assets/Wallet/pending.svg";
// import { useTranslation } from 'react-i18next';
// import valid from "../assets/Attendance/valid.svg"
// import i18n from 'i18next';
// import cancel from "../assets/StatusIcons/cancel.svg";
// import expire from "../assets/StatusIcons/expire.svg";
// import tobepaid from "../assets/StatusIcons/tobepaid.svg";

// /** Renders SVG as a mask so the glyph uses `currentColor` (matches badge text). */
// const StatusGlyphIcon = ({ src, size = 20 }) => {
//   if (!src) return null;
//   return (
//     <Box
//       component="span"
//       aria-hidden
//       sx={{
//         display: "inline-block",
//         width: size,
//         height: size,
//         flexShrink: 0,
//         bgcolor: "currentColor",
//         maskImage: `url(${src})`,
//         maskSize: "contain",
//         maskRepeat: "no-repeat",
//         maskPosition: "center",
//         WebkitMaskImage: `url(${src})`,
//         WebkitMaskSize: "contain",
//         WebkitMaskRepeat: "no-repeat",
//         WebkitMaskPosition: "center",
//       }}
//     />
//   );
// };

// const statusIcons = {
//   Present: present,
// cancelled: cancel,
// CANCELLED: cancel,

// expired: expire,
//    Validated: present,
//    CLOCK_IN:present,
//   Paid:present,
//     paid:present,

//   Completed: present,
//     completed: present,
//  Verified: present,
//   verified: present,
//     Approved: present,
//         approved: present,

//      APPROVED: present,
//   Absent: absent,
//   Invalid:absent,
//  Error: absent,
//   Delayed: absent,
//    Rejected: absent,
//       rejected: absent,

//    CLOCK_OUT:absent,
//       REJECTED: absent,
//   Leave: leave,
//   assigned: leave,
//    Assigned: leave,
//   Pending:leave,
//     pending:leave,
//   pendingPunch:halfleave,
// INFO_REQUESTED:halfleave,
//   PENDING:leave,
//     valid:valid,
//   'Early Out': earlyout,
//   'Has Issues' :earlyout, 
//     Ongoing: earlyout,      // ✅ Use quotes because of the space
//   'Late Arrival': late,
//    'in_progress': late,
//   'Half Day': halfleave,
//    Paused: halfleave,
//     'Requested': halfleave,
//         'Request': halfleave,
//         toBePaid: tobepaid,
//     Active: present,
//       active:present,
//   Invited: invited,
//     invited: invited,
//     Requested: request,
//      Inactive: inactive,
//      high:task,
//      medium:task,
//      urgent:task,
//      u:task,
//      low:task,
//      invalidPunch:absent,
//      validatedPunch:present,
//         BACK_FROM_BREAK:halfleave,
//      BREAK_END:halfleave,
//      BREAK_START:late,
//   // Attendance schedule classifications
//   ON_TIME_CLOCK_IN: present,
//   EARLY_CLOCK_IN: present,
//   LATE_CLOCK_IN: late,
//   ON_TIME_CLOCK_OUT: absent,
//   EARLY_CLOCK_OUT: earlyout,
//   LATE_CLOCK_OUT: late,
//   NOT_APPLICABLE: halfleave,

// };
// const statusStyles = {
//   CLOCK_IN:{ backgroundColor: '#4BCE97', color: '#164B35' },
//   Present: { backgroundColor: '#4BCE97', color: '#164B35' },
//     APPROVED: { backgroundColor: '#4BCE97', color: '#164B35' },
//   Validated: { backgroundColor: '#4BCE97', color: '#164B35' },
//     Paid: {    backgroundColor: "#CFF3E1",
//   color: "#0F6A4F",},
//     paid: {    backgroundColor: "#CFF3E1",
//   color: "#0F6A4F", },
//   Completed: { backgroundColor: '#4BCE97', color: '#164B35' },
//     completed: { backgroundColor: '#4BCE97', color: '#164B35' },
//  Verified: { backgroundColor: '#4BCE97', color: '#164B35' },
//   verified: { backgroundColor: '#4BCE97', color: '#164B35' },
//   Approved: { backgroundColor: '#4BCE97', color: '#164B35' },
//     approved: { backgroundColor: '#4BCE97', color: '#164B35' },
//   cancelled:{ backgroundColor: '#FEA362', color: '#702E00' },
//     CANCELLED:{ backgroundColor: '#FEA362', color: '#702E00' },

//     expired:{ backgroundColor: '#091E4224', color: '#44546F' },
//   Absent: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Invalid: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Error: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Delayed: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   Rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
//     REJECTED: { backgroundColor: '#F87168', color: '#5D1F1A' },
//      CLOCK_OUT: { backgroundColor: '#F87168', color: '#5D1F1A' },
//   invalidPunch:{ backgroundColor: '#F87168', color: '#5D1F1A'},
//   Leave: { backgroundColor: '#579DFF', color: '#09326C' },
//   INFO_REQUESTED:{ backgroundColor: '#F5CD47', color: '#533F04'},
//   assigned: { backgroundColor: '#579DFF', color: '#09326C' },
//     Assigned: { backgroundColor: '#579DFF', color: '#09326C' },
//       BACK_FROM_BREAK: { backgroundColor: '#F5CD47', color: '#533F04' },
// BREAK_START:{ backgroundColor: '#FEA362', color: '#702E00'},
//           BREAK_END: { backgroundColor: '#F5CD47', color: '#533F04' },

// Pending: { backgroundColor: '#579DFF', color: '#09326C' },
// pending: { backgroundColor: '#579DFF', color: '#09326C' },
// PENDING: { backgroundColor: '#579DFF', color: '#09326C' },
// pendingPunch: { backgroundColor: '#F5CD47', color: '#533F04' },
// validatedPunch: { backgroundColor: '#4BCE97', color: '#164B35' },
//   'Early Out': { backgroundColor: '#9F8FEF', color: '#352C63' }, // ✅ Fix here
//   'Has Issues': { backgroundColor: '#9F8FEF', color: '#352C63' }, 
//    Ongoing: { backgroundColor: '#9F8FEF', color: '#352C63' },
//   'Late Arrival': { backgroundColor: '#FEA362', color: '#702E00' },
//    'in_progress': { backgroundColor: '#FEA362', color: '#702E00' },
//   'Half Day': { backgroundColor: '#F5CD47', color: '#533F04' },
//    Paused: { backgroundColor: '#F5CD47', color: '#533F04' },
//    'Requested': { backgroundColor: '#F5CD47', color: '#533F04' },
//    'Request': { backgroundColor: '#F5CD47', color: '#533F04' },
//      Active: { backgroundColor: '#4BCE97', color: '#164B35' },
//           active: { backgroundColor: '#4BCE97', color: '#164B35' },
//         Invited: { backgroundColor: '#579DFF', color: '#09326C' },
//          invited: { backgroundColor: '#579DFF', color: '#09326C' },
//          toBePaid: { backgroundColor: '#579DFF', color: '#09326C' },
//          Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
//           Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
//       low: { backgroundColor: '#BCBFC2', color: '#44546F' },
//         medium: {backgroundColor: '#9B8CFF',
// color: '#2D1E73'},
//        high: { backgroundColor: '#FEA362', color: '#702E00' },
//      urgent: { backgroundColor: '#F87168', color: '#5D1F1A' },
//      valid: { backgroundColor: '#579DFF', color: '#ffffff' },
//   // Attendance schedule classifications (palette — do not alter existing keys above)
//   ON_TIME_CLOCK_IN: { backgroundColor: '#16A34A', color: '#052E16' },
//   EARLY_CLOCK_IN: { backgroundColor: '#7DD3FC', color: '#0C4A6E' },
//   LATE_CLOCK_IN: { backgroundColor: '#CBD5E1', color: '#0F172A' },
//   ON_TIME_CLOCK_OUT: { backgroundColor: '#2563EB', color: '#172554' },
//   EARLY_CLOCK_OUT: { backgroundColor: '#1E40AF', color: '#BFDBFE' },
//   LATE_CLOCK_OUT: { backgroundColor: '#991B1B', color: '#FECACA' },
//   NOT_APPLICABLE: { backgroundColor: '#D1D5DB', color: '#374151' },
// };

// const canOpenDropdown = Object.keys(statusStyles).filter(
//   (status) => status !== "" && status !== "Received"
// );
// const showDropdownIcon = ["", "", "", "", "", ""];

// const StatusDropdown = ({ currentStatus, onChange, statusOptions = [] }) => {
//   const { t, i18n } = useTranslation();

//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const handleClick = (event) => {
//     if (canOpenDropdown.includes(currentStatus)) {
//       setAnchorEl(event.currentTarget);
//     }
//   };
//   const handleClose = (status) => {
//     if (status) onChange(status);
//     setAnchorEl(null);
//   };
//   const displayStatusLabels = {
//   initiated: 'Processing',
//   success: 'Paid',
//   failed: 'Failed',
// };
//   return (
//     <>
//       {/* <Box
//         onClick={handleClick}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           gap: 0.5,
//           px: 0.4,
//           py: 0.4,
//           borderRadius: '4px',
//           fontWeight: 400,
//           fontFamily: 'Poppins, sans-serif',
//           fontSize: '13px',
//           cursor: canOpenDropdown.includes(currentStatus) ? 'pointer' : 'default',
//           width: 'fit-content',
//           cursor:"pointer",
//               whiteSpace: 'nowrap',         // ✅ no line break

//           ...statusStyles[currentStatus]
//         }}
//       > */}
//       <Box
//   onClick={handleClick}
//   sx={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 0.5,
//     px: 1,
//     py: 0.4,
//     borderRadius: "6px",
//     fontWeight: 500,
//     fontFamily: "Poppins, sans-serif",
//     fontSize: "13px",
//     cursor: canOpenDropdown.includes(currentStatus) ? "pointer" : "default",

//     // 🌍 Responsive equal width logic
//     flex: 1,                            // take full space inside table cell
//    maxWidth: i18n.language === "es" ? 160 : 150,                   // prevent overflow
//     minWidth: 120,                      // ensure equal base size
//     width: "100%",                      // allow auto-fit
//     textAlign: "center",
//     whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",

//     ...statusStyles[currentStatus],
//     color: statusStyles[currentStatus]?.color || "#333333",
//   }}
// >
//         <StatusGlyphIcon src={statusIcons[currentStatus]} size={20} />

//         <Typography
//           sx={{
//             fontSize: "13px",
//             fontFamily: "Poppins, sans-serif",
//             color: "inherit",
//           }}
//         >
//           {t(`statuses.${displayStatusLabels[currentStatus] || currentStatus}`)}
//         </Typography>
//         {showDropdownIcon.includes(currentStatus) && (
//           <ArrowDropDownIcon sx={{ fontSize: 18, color: "inherit" }} />
//         )}
//       </Box>

//       <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
       
//         {statusOptions.map((status) => (
//   <MenuItem key={status} onClick={() => handleClose(status)}>
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: 1,
//         color: statusStyles[status]?.color || "#333333",
//       }}
//     >
//       <StatusGlyphIcon src={statusIcons[status]} size={16} />
//       <Typography
//         sx={{ fontFamily: "Poppins, sans-serif", fontSize: "13px", color: "inherit" }}
//       >
//         {t(`statuses.${status}`)}
//       </Typography>
//     </Box>
//   </MenuItem>
// ))}
//       </Menu>
//     </>
//   );
// };

// /** Same key as StatusDropdown `currentStatus` (classification, with break NOT_APPLICABLE → action type). */
// export function resolveAttendanceStatusKey(statusKey, fallbackActionType) {
//   const classification =
//     statusKey != null && String(statusKey).trim() !== ""
//       ? String(statusKey).trim()
//       : "";
//   const action = fallbackActionType;
//   if (classification) {
//     if (
//       (action === "BREAK_START" || action === "BREAK_END") &&
//       classification === "NOT_APPLICABLE"
//     ) {
//       return action;
//     }
//     return classification;
//   }
//   return action;
// }

// /** Punch indicator / map pin fill — matches StatusDropdown badge `backgroundColor`. */
// export function getAttendanceStatusDotColor(statusKey, fallbackActionType) {
//   const key = resolveAttendanceStatusKey(statusKey, fallbackActionType);
//   const style = (key && statusStyles[key]) || statusStyles.CLOCK_IN;
//   return style?.backgroundColor ?? "#2E7DFF";
// }

// /** Map pin icon filled with the same color as the status badge (not a circle dot). */
// export function getAttendanceStatusPinMarkerIcon(statusKey, fallbackActionType) {
//   const fillColor = getAttendanceStatusDotColor(statusKey, fallbackActionType);
//   const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
//   <path fill="${fillColor}" stroke="#FFFFFF" stroke-width="1.5" d="M12.5 0C5.596 0 0 5.596 0 12.5c0 7.904 12.5 28.5 12.5 28.5S25 20.404 25 12.5C25 5.596 19.404 0 12.5 0z"/>
//   <circle cx="12.5" cy="12" r="4.5" fill="#FFFFFF" fill-opacity="0.9"/>
// </svg>`;
//   const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

//   if (typeof window !== "undefined" && window.google?.maps?.Size && window.google?.maps?.Point) {
//     return {
//       url,
//       scaledSize: new window.google.maps.Size(25, 41),
//       anchor: new window.google.maps.Point(12, 41),
//     };
//   }
//   return { url };
// }

// /** @deprecated Use getAttendanceStatusPinMarkerIcon — kept for imports during migration */
// export function getAttendanceStatusMapMarkerIcon(statusKey, fallbackActionType) {
//   return getAttendanceStatusPinMarkerIcon(statusKey, fallbackActionType);
// }

// export default StatusDropdown;




